import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const RaffleEventModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom) + 74px;
  padding-bottom: calc(env(safe-area-inset-bottom) + 74px);
  background-color: #fff;
  max-height: 70vh;
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  overflow-y: auto;

  &.is-old-app-iphonex {
    padding-bottom: 30px;
  }

  .modal-edge-close-btn {
    z-index: 11;
  }

  .content {
    padding: 0 20px 20px 20px;

    > div + div {
      margin-top: 6px;
    }

    .all-agree {
      ${mixin.flex({
        direction: 'column',
        align: 'flex-start',
        justify: 'center',
      })}
      row-gap: 5px;
      margin-bottom: 24px;
      margin-left: 8px;

      label.checkbox {
        display: flex;
        width: 100%;

        .label {
          font-size: 16px;
          font-weight: 600;
        }
      }

      .text {
        margin-left: 28px;
        line-height: 130%;
        font-size: 12px;
      }
    }

    .accordion-base {
      background-color: #f9f9f9;
    }

    .accordion-item .accordion-label {
      ${mixin.flex({})}
      height: 67px;
      margin: 0;
      padding: 10px 16px;

      .btn.label {
        /* 아코디언 label */
        padding: 0;
      }

      .checkbox {
        position: relative;
        z-index: 10;
        pointer-events: auto;

        .label {
          /* 체크박스 label */
          justify-content: flex-end;
          width: ${mixin.pxToVw('230')};
          margin: 0 0 0 10px;
          line-height: 130%;
          text-align: left;
          font-size: 14px;
          font-weight: 500;
        }

        input[type='checkbox']:not(:checked) + svg {
          background-color: #fff;
        }
      }
    }

    .agree-notice {
      padding: 16px 12px;
      border-top: 1px solid #eee;

      table.agree-notice-table {
        width: 100%;
        margin-bottom: 10px;
        border-collapse: collapse;
        border: 1px solid #e5e5e5;

        th,
        td {
          border: 1px solid #e3e3e3;
          line-height: 150%;
          font-size: 13px;
          vertical-align: middle;
          word-break: keep-all;
          color: #000;
        }

        th {
          height: 34px;
          padding: 7px 10px;
          font-weight: 600;
          text-align: center;
          background-color: #ededed;
        }

        td {
          padding: 10px;
          text-align: left;
        }

        td:first-child {
          text-align: center;
        }
      }

      dl.agree-notice-desc {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 4px 10px;

        dt,
        dd {
          line-height: 150%;
          font-size: 13px;
        }

        dt {
          position: relative;
          font-weight: 500;

          &:before {
            content: '·';
            font-size: 19px;
            padding-right: 6px;
            vertical-align: top;
          }
        }

        dd {
          font-weight: 400;
        }
      }

      ul.agree-notice-list {
        li {
          position: relative;
          line-height: 150%;
          font-size: 13px;
          font-weight: 600;

          & + li {
            margin-top: 4px;
          }
        }
      }
    }

    .caution-text {
      display: block;
      margin: 12px auto 0;
      padding: 8px 16px;
      border-radius: 3px;
      line-height: 130%;
      font-size: 12px;
      color: #555;
      background-color: #f1f1f1;
    }
  }

  .modal-group-btn {
    position: fixed;
    bottom: 0 !important;
    left: 0;
    width: 100%;
    padding: 14px 20px calc(env(safe-area-inset-bottom) + 10px);
    z-index: 10;

    &:after {
      display: none;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    &.is-old-app-iphonex {
      padding-bottom: ${mixin.pxToVw('30')};
    }

    .content {
      padding: ${mixin.pxToVw('0 20 20 20')};

      > div + div {
        margin-top: ${mixin.pxToVw('6')};
      }

      .all-agree {
        row-gap: ${mixin.pxToVw('5')};
        margin-bottom: ${mixin.pxToVw('24')};
        margin-left: ${mixin.pxToVw('8')};

        label.checkbox {
          .label {
            font-size: ${mixin.pxToVw('16')};
          }
        }

        .text {
          margin-left: ${mixin.pxToVw('28')};
          font-size: ${mixin.pxToVw('12')};
        }
      }

      .accordion-base {
        background-color: #f9f9f9;
      }

      .accordion-item .accordion-label {
        height: ${mixin.pxToVw('67')};
        padding: ${mixin.pxToVw('10 20 10 10')};

        .checkbox {
          .label {
            /* 체크박스 label */
            margin: 0 0 0 ${mixin.pxToVw('10')};
            font-size: ${mixin.pxToVw('14')};
          }
        }
      }

      .agree-notice {
        padding: ${mixin.pxToVw('16 12')};

        table.agree-notice-table {
          width: 100%;
          margin-bottom: ${mixin.pxToVw('10')};

          th,
          td {
            font-size: ${mixin.pxToVw('13')};
          }

          th {
            height: ${mixin.pxToVw('34')};
            padding: ${mixin.pxToVw('7 10')};
          }

          td {
            padding: ${mixin.pxToVw('10')};
          }
        }

        dl.agree-notice-desc {
          gap: ${mixin.pxToVw('4 10')};

          dt,
          dd {
            line-height: ${mixin.pxToVw('150%')};
            font-size: ${mixin.pxToVw('13')};
          }
        }

        ul.agree-notice-list {
          li {
            font-size: ${mixin.pxToVw('13')};

            & + li {
              margin-top: ${mixin.pxToVw('4')};
            }
          }
        }
      }

      .caution-text {
        display: block;
        margin: ${mixin.pxToVw('12 auto 0')};
        padding: ${mixin.pxToVw('8 16')};
        border-radius: ${mixin.pxToVw('3')};
        font-size: ${mixin.pxToVw('12')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: 680px;
    height: auto;
    padding-bottom: 120px;
    border-radius: 0;
    width: 450px;

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;
    }

    .modal-title {
      position: relative;
      padding: 62px 44px 32px;
      margin-bottom: 0;
    }

    .content {
      padding: 0 32px 8px;

      .all-agree {
        margin-bottom: 23px;

        label.checkbox {
          cursor: pointer;
        }
      }

      .accordion-item .accordion-label {
        height: 56px;

        .checkbox {
          cursor: pointer;

          .label {
            /* 체크박스 label */
            width: 250px;
            font-size: 15px;
          }
        }
      }

      .agree-notice {
        padding: 16px 13px 20px 12px;
      }
    }

    .modal-group-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 10;
      padding: 32px 32px;
    }
  }
`;
